import React from 'react';
import PreviewSection from './preview_section/preview_section';
import InfoSection from './info_section/info_section';

import './landing.scss';

export default function Landing() {
  return (
    <div className="landing">
      <PreviewSection />
      {/*
        TODO: Extract app stores links into their own component
        --georgi.ivanov@2018-03-22
      */}
      <div className="app-stores">
        <div className="app-stores-message">Use TeamHub with your <b>Apple TV</b>, <b>Android TV</b> or <b>Chromecast</b></div>
        <div className="apple-tv">
          <a
            href="https://itunes.apple.com/us/app/teamhub-player/id1341756979"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="./static/apple_tv_app_store_badge.svg"
              alt="Download from AppStore"
            />
          </a>
        </div>
        <div className="google-play">
          <a
            href="https://play.google.com/store/apps/details?id=tv.teamhub.teamhubtv&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
            />
          </a>
        </div>
      </div>
      <InfoSection />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/landing/landing.jsx